<template>
  <div class="form-wrapper">
    <!--快捷回访 部分 S-->
    <div v-show="this.type === 'visit'">
      <el-form
        ref="visitForm"
        :model="visitShadow"
        :rules="rules"
        label-width="100px">
        <el-form-item
          v-if="$siteName === 'training' && $hasPermission(80) && !dataSet.id"
          label="预计下次回访时间："
          prop="visit_tk_time">
          <el-date-picker
            class="jm-input220"
            v-model="visitShadow['visit_tk_time']"
            type="datetime"
            placeholder="选择日期时间"/>
        </el-form-item>
        <el-form-item
          label="方式："
          :prop="['writeOperate','training'].indexOf(this.operateVisit) ? 'visit_kind' : ''">
          <jm-dict-select
            clearable
            class="jm-input220"
            dict="dataset.visit.way"
            v-model="visitShadow['visit_kind']"
          />
        </el-form-item>
        <el-form-item
          v-if="showActivity"
          label="活动："
          prop="activity_id">
          <el-select
            class="jm-input220"
            placeholder="请选择"
            v-model="visitShadow['activity_id']"
            clearable>
            <el-option
              v-for="item in activityList"
              :key="item.id"
              :label="item.act_title"
              :value="item.id"/>
          </el-select>
        </el-form-item>

        <el-form-item label="快捷记录：" v-if="this.operateVisit === 'writeOperate'">
          <jm-dict-select
            clearable
            class="jm-input220"
            dict="dataset.visit.quickRecordWriterVisit"
            v-model="visitShadow['record']"
            @change="quickFill"
          />
        </el-form-item>
        <el-form-item label="快捷记录：" v-else-if="this.operateVisit === 'training'">
          <jm-dict-select
            clearable
            class="jm-input220"
            dict="dataset.visit.quickRecordTraining"
            v-model="visitShadow['record']"
            @change="quickFill"
          />
        </el-form-item>
        <el-form-item label="快捷记录：" v-else>
          <jm-dict-select
            clearable
            class="jm-input220"
            dict="dataset.visit.quickRecord"
            v-model="visitShadow['record']"
            @change="quickFill"
          />
        </el-form-item>
        <el-form-item
          label="回访类型："
          v-if="showVisitType"
          :prop="($hasPermission(1) || isNormal) ? 'visit_type' : ''">
          <jm-dict-select
            :clearable="$hasPermission(1) || isNormal"
            class="jm-input220"
            dict="dataset.visit.type"
            v-model="visitShadow['visit_type']"
            :filter="visitTypeFilter"
          />
        </el-form-item>
        <el-form-item
          label="意向国家："
          prop="custom_hope_country"
          v-if="title === '资源激活' || (this.operateVisit === 'fibOperate' && visitShadow['visit_type'] === 2 && (([58, 66].indexOf(this.crmLevelLv) > -1) || ([131505].indexOf(this.crm_sayer) > -1)))">
          <el-select
            v-model="visitShadow['custom_hope_country']"
            class="jm-input220"
            placeholder="请选择"
            clearable>
            <el-option
              v-for="item in countriesData"
              :key="item.id"
              :label="item.value"
              :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item
          label="记录："
          prop="vist_str">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="visitShadow['vist_str']"/>
        </el-form-item>
        <!-- v-if="$siteName === 'training'" -->
        <el-form-item
          label="上传截图："
          prop="url">
          <jm-upload
            class="reuse-uploader"
            action="/newfib.php/index/api_base/uploadSimpleFile/type/visit"
            :show-file-list="false"
            :on-success="handleImgSuccess"
            :before-upload="beforeImgUpload">
            <img v-if="visitShadow['url']" :src="visitShadow['url']" class="reuse-img">
            <i v-else class="el-icon-plus reuse-uploader-icon"></i>
          </jm-upload>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="saveVisit('visitForm', title)"
          >
            {{ title === '资源激活' ? '激活' : '保存' }}
          </el-button>
          <el-button
            type="danger"
            size="small"
            @click="closeHandle">关闭</el-button>
        </el-form-item>
      </el-form>
      <div class="form-tip" v-if="this.operateVisit !== 'writeOperate'">
        <p>联系型：指本次回访尝试联系学生但未成功。</p>
        <p>跟进型：指本次回访成功联系到学生，无论学生是否有意向都归类为跟进型回访。</p>
      </div>
    </div>
    <!--快捷回访 部分 E-->
    <!--预约回访 部分 S-->
    <div v-show="this.type === 'appointment'">
      <el-form
        ref="appointmentForm"
        :model="appointmentShadow"
        :rules="rules"
        label-width="70px"
        class="demo-ruleForm">
        <el-form-item
          label="时间："
          prop="tk_time">
          <el-date-picker
            class="jm-input220"
            v-model="appointmentShadow['tk_time']"
            type="datetime"
            placeholder="选择日期时间"/>
        </el-form-item>
        <el-form-item label="性质：">
          预约回访
        </el-form-item>
        <el-form-item label="学生：">
          <span v-if="studentInfo.custom_name">
            姓名：【{{ studentInfo.custom_name }}】
          </span>
          <span v-if="studentInfo.crm_qq">
            QQ：【{{ studentInfo.crm_qq }}】
          </span>
          <span v-if="studentInfo.crm_tel">
            电话：【{{ studentInfo.crm_tel }}】
          </span>
          <span v-if="studentInfo.crm_weixin">
            微信：【{{ studentInfo.crm_weixin }}】
          </span>
        </el-form-item>
        <el-form-item
          label="说明："
          prop="tk_memo">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="appointmentShadow['tk_memo']"/>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="saveAppointment('appointmentForm')">保存</el-button>
          <el-button
            type="danger"
            size="small"
            @click="closeHandle">关闭</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <!--预约回访 部分 E-->
</template>
<script>
import * as moment from 'moment';
import { mapGetters } from 'vuex';
import { jmDictSelect } from '@/components/tool';
import * as visitDataset from '@/dataset/visit';

const rules = {
  tk_time: [
    { required: true, message: '请选择时间', trigger: 'change' },
  ],
  tk_memo: [
    { required: true, message: '请输入内容', trigger: 'blur' },
    { min: 10, message: '长度不能小于10个字符', trigger: 'blur' }
  ],
  visit_kind: [
    {
      type: 'number', required: true, message: '请选择联系方式', trigger: 'change'
    },
  ],
  visit_type: [
    {
      type: 'number', required: true, message: '请选择回访类型', trigger: 'change'
    },
  ],
  custom_hope_country: [
    {
      type: 'number', required: true, message: '请选择意向国家', trigger: 'change'
    },
  ],
  vist_str: [
    { required: true, message: '请输入内容', trigger: 'blur' },
    { min: 10, message: '长度不能小于10个字符', trigger: 'blur' }
  ],
};
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    dataSet: {
      type: Object,
      default () {
        return {};
      }
    },
    operateVisit: { type: String, default: '' },
    increaseType: { type: String, default: '' },
    crmLevelLv: { type: Number, default: 0 },
    crm_level: { type: Number, default: 0 },
    crm_sayer: { type: [Number, String], default: 0 },
  },
  watch: {
    visible(v) {
      if (v === false) {
        this.appointmentShadow = {
          tk_time: '',
          tk_memo: '',
        };
        this.visitShadow = {
          visit_tk_time: '',
          visit_kind: '',
          activity_id: '',
          record: '',
          visit_type: '',
          custom_hope_country: '',
          vist_str: '',
          url: '',
          path: ''
        };
        this.studentInfo = {};
      }
    },
    dataSet() {
      this.initVisitData();
      this.initUserInfo();
    },
  },
  mounted() {
    this.initVisitData();
    this.initActivityList();
    this.initUserInfo();
    this.getCountries().then((data) => {
      this.countriesData = data;
    });
  },
  components: {
    jmDictSelect,
  },
  data() {
    return {
      appointmentShadow: {
        tk_time: '',
        tk_memo: '',
      },
      visitShadow: {
        visit_tk_time: '', // 仅考培用，下次预约时间
        visit_kind: '',
        record: '',
        visit_type: '',
        custom_hope_country: '',
        vist_str: '',
        url: '',
        path: '',
      },
      studentInfo: {},
      activityList: [],
      rules,
      countriesData: '',
    };
  },
  computed: {
    ...mapGetters(['userInfo']), // this.userInfo
    tkName() {
      let tkname = this.studentInfo.custom_name ? `姓名: 【${this.studentInfo.custom_name}】 ` : '';
      let tkqq = this.studentInfo.crm_qq ? `QQ: 【${this.studentInfo.crm_qq}】 ` : '';
      let tktel = this.studentInfo.crm_tel ? `电话:【${this.studentInfo.crm_tel}】 ` : '';
      let tkweixin = this.studentInfo.crm_weixin ? `微信: 【${this.studentInfo.crm_weixin}】 ` : '';
      return `${tkname}${tkqq}${tktel}${tkweixin}`;
    },
    isNormal() {
      return !this.$hasPermission([53]) // 待激活咨询
        && (
          this.userInfo.stations.indexOf(6) > -1
          || this.userInfo.stations.indexOf(10) > -1
          || this.$hasPermission([93, 52, 90, 109]) // 前程日本客户经理, 学生编辑组, 海外求职咨询, 海外求职技术类咨询
        );
    },
    showVisitType() { // 回访类型
      return this.$siteName !== 'teaching'
          && this.operateVisit !== 'writeOperate'
          && this.operateVisit !== 'planningOperate';
    },
    showActivity() { // 活动
      return this.$siteName !== 'teaching'
          && this.operateVisit !== 'writeOperate'
          && this.operateVisit !== 'planningOperate';
    }
  },
  methods: {
    closeHandle() {
      this.$emit('update:visible', false);
      this.$store.commit('upClickSave', false);
    },
    /**
     * 保存预约回访
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    saveAppointment(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.appointmentForm();
        }
      });
    },
    /**
     * 学生回访
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    saveVisit(formName, title) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.visitForm(title);
        }
      });
    },
    /**
     * 预约回访 处理请求
     * */
    appointmentForm() {
      let datatkname = this.tkName;
      let delayTime = '';
      if (this.appointmentShadow.tk_time !== undefined && this.appointmentShadow.tk_time !== '') {
        delayTime = moment(this.appointmentShadow.tk_time).format('YYYY-MM-DD HH:mm:ss');
      }
      let data = this.appointmentShadow;
      data.crm_id = this.dataSet.crmid;
      data.tk_name = datatkname;
      data.tk_time = delayTime;
      data.tk_type = 1;
      let urlList = {
        fib: '/index/Message/savePlanTask',
        training: '/training/Plantask/resource',
        job: '/job/Plantask/resource',
      };
      let saveUrl = urlList[this.$siteName] ? urlList[this.$siteName] : urlList.fib;
      this.$http._post({
        url: saveUrl,
        data
      }).then(() => {
        this.$message.success('保存成功');
        this.$store.commit('updateRefresh', true);
        this.closeHandle();
      }).catch(() => {
        this.$message.error('保存失败');
      });
    },
    handleImgSuccess(res) {
      this.visitShadow.path = res.data.path;
      this.visitShadow.url = res.data.url;
      // this.visitShadow.url = "https://imghome.jiemo.net//Upload/reuse/20220311091205704.jpg";
    },
    beforeImgUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB');
      }
      return isJPG && isLt2M;
    },
    /**
     * 学生回访 处理请求
     */
    visitForm(title) {
      let data = this.visitShadow;
      data.userid = this.dataSet.crmid;
      data.tk_name = this.tkName;

      if (title === '资源激活') {
        data.isActivate = 1;
      }

      let urlList = {
        fib: '/index/visit/resource',
        training: '/training/visit/resource',
        job: '/job/visit/resource',
        teaching: '/teaching/visit/resource',
        fibOperate: '/index/operate_visit/resource', // 蓝火系统，用户运营回访
        trainingOperate: '/training/operate_visit/resource', // 星图系统，用户运营回访
        jobOperate: '/job/operate_visit/resource', // 星火系统，用户运营回访
        writeOperate: '/index/write_visit/resource',
        planningOperate: '/index/plan_visit/resource',
      };
      let saveUrl = '';
      if (this.operateVisit !== '') {
        saveUrl = urlList[this.operateVisit] ? urlList[this.operateVisit] : urlList.fib;
      } else {
        saveUrl = urlList[this.$siteName] ? urlList[this.$siteName] : urlList.fib;
      }

      if (this.crm_level === 55 && this.visitShadow.visit_type !== 2) {
        return this.$message.error('请选择跟进型回访类型');
      }
      this.$http._post({
        url: saveUrl,
        data
      }).then(() => {
        if (!this.$store.state.clickSave) {
          this.$message.success(title === '资源激活' ? '激活成功' : '保存成功');
        }
        if (this.$siteName !== 'fib') {
          this.$store.commit('updateRefresh', true);
        }
        this.$store.commit('upNewVisit', true);
        this.$emit('update:visible', false);
        this.$emit('finished', { type: this.operateVisit });
      }).catch((e) => {
        if (e.data.msg) {
          this.$message.error(e.data.msg);
        } else {
          this.$message.error('保存失败');
        }
      });
    },
    /*
    * 重置表单
    * */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    quickFill(v) {
      const ds = [...visitDataset.quickRecord, ...visitDataset.quickRecordWriterVisit, ...visitDataset.quickRecordTraining];
      console.info(ds);
      ds.forEach((item) => {
        if (item.value === v) {
          this.visitShadow.vist_str = item.label;
        }
      });
    },
    /**
     * 获取 visit 数据
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    initVisitData() {
      if (this.$hasPermission([53, 117, 158])) {
        this.visitShadow.visit_type = 3;
      }

      if (this.$hasPermission(1) && this.increaseType === 'increase') {
        this.visitShadow.visit_type = '';
      }

      if (!this.dataSet.id) {
        return false;
      }
      let urlList = {
        fib: `/index/visit/resource/id/${this.dataSet.id}`,
        teaching: `/teaching/visit/resource/id/${this.dataSet.id}`,
        training: `/training/visit/resource/id/${this.dataSet.id}`,
        job: `/job/visit/resource/id/${this.dataSet.id}`,
        fibOperate: `/index/operate_visit/resource/id/${this.dataSet.id}`,
        trainingOperate: `/training/operate_visit/resource/id/${this.dataSet.id}`,
        jobOperate: `/job/operate_visit/resource/id/${this.dataSet.id}`,
        writeOperate: `/index/write_visit/resource/id/${this.dataSet.id}`,
        planningOperate: `/index/plan_visit/resource/id/${this.dataSet.id}`,
      };
      let readUrl = '';
      if (this.operateVisit !== '') {
        readUrl = urlList[this.operateVisit] ? urlList[this.operateVisit] : urlList.fib;
      } else {
        readUrl = urlList[this.$siteName] ? urlList[this.$siteName] : urlList.fib;
      }

      this.$http._get({
        url: readUrl,
      }).then(({ data }) => {
        if (data.visit_type === 0) {
          data.visit_type = '';
        }
        this.visitShadow = data;
      });
    },
    /**
     * 用户信息初始化
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     */
    initUserInfo() {
      if (!this.dataSet.crmid) {
        return false;
      }
      let urlList = {
        fib: `/index/student/resource/id/${this.dataSet.crmid}`,
        teaching: `/teaching/student/resource/id/${this.dataSet.crmid}`,
        job: `/job/Plantask/studentInfo/id/${this.dataSet.crmid}`,
        training: `/training/Plantask/studentInfo/id/${this.dataSet.crmid}`,
      };
      let infoUrl = '';
      console.log(this.$siteName);
      infoUrl = urlList[this.$siteName] ? urlList[this.$siteName] : urlList.fib;
      this.$http._get({
        url: infoUrl
      }).then(({ data }) => {
        this.studentInfo = data;
      });
    },
    initActivityList() {
      if (this.showActivity) {
        this.$http._get({
          url: `/index/general_activity/showActivityListBySiteName/siteName/${this.$siteName}`
        }).then(({ data }) => {
          this.activityList = data;
        });
      }
    },
    /**
     * Description: 意向国家
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getCountries() {
      return new Promise((resolve) => {
        this.$http._get({
          url: 'index/api_base/hopeCountry',
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
     * 回访类型，感觉不同角色使用不用的类型
     */
    visitTypeFilter(item) {
      // 117 用户运营
      if (this.$hasPermission([91, 1, 98, 114, 117])) {
        return true;
      }

      // 149 星耀东大咨询
      if (this.$hasPermission([149])) {
        if (item.value === 1 || item.value === 2 || item.value === 3) {
          return true;
        }
        return false;
      }


      if (this.$hasPermission([84])) {
        if (item.value === 2 || item.value === 3 || item.value === 21 || item.value === 22) {
          return true;
        }
        return false;
      }

      if (this.isNormal) {
        if (item.value === 1 || item.value === 2) {
          return true;
        }
        return false;
      }

      if (item.value === 3) {
        return true;
      }
      return false;
    }
  },
};
</script>
<style scoped>
.form-wrapper {
  padding: 20px 20px 1px 20px;
  position: relative;
}

.form-tip{
  position: absolute;
  z-index: 10000000;
  right: 34px;
  top: 55px;
  width: 300px;
}

/* 上传截图 */
.reuse-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.reuse-uploader /deep/ .el-upload:hover {
  border-color: #409EFF;
}

.reuse-uploader /deep/ .reuse-uploader-icon {
  display: inline-block;
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.reuse-uploader /deep/ .reuse-img {
  max-width: 150px;
  display: block;
}
</style>
